import React from 'react';

const userIcon = (props) => (
    <svg width="13" height="14" viewBox="0 0 13 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M6.41667 7.875C8.40934 7.875 10.026 6.11133 10.026 3.9375C10.026 1.76367 8.40934 0 6.41667 0C4.42399 0 2.80729 1.76367 2.80729 3.9375C2.80729 6.11133 4.42399 7.875 6.41667 7.875ZM9.625 8.75H8.24391C7.68747 9.02891 7.06836 9.1875 6.41667 9.1875C5.76497 9.1875 5.14837 9.02891 4.58942 8.75H3.20833C1.43623 8.75 0 10.3168 0 12.25V12.6875C0 13.4121 0.5389 14 1.20312 14H11.6302C12.2944 14 12.8333 13.4121 12.8333 12.6875V12.25C12.8333 10.3168 11.3971 8.75 9.625 8.75Z" fill="#5E2F8B"/>
    </svg>

);
export default  userIcon